import { render, staticRenderFns } from "./EmSppWarehousingDetSwdList.vue?vue&type=template&id=4890ec61&"
import script from "./EmSppWarehousingDetSwdList.vue?vue&type=script&lang=js&"
export * from "./EmSppWarehousingDetSwdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports